/** Navigation accepts a single Prime icon pair or a Material glyph name. */
export function primeNavigationIcon(
  value: string | null | undefined,
): string | null {
  return typeof value === 'string' &&
    value.trim() === value &&
    /^pi pi-[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value)
    ? value
    : null;
}

export function materialNavigationIcon(
  value: string | null | undefined,
  fallback = 'account_tree',
): string {
  return typeof value === 'string' &&
    value.trim() === value &&
    /^[a-z][a-z0-9_]*$/.test(value)
    ? value
    : fallback;
}
